import React, {useEffect} from 'react';
// import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {NavLink} from "react-router-dom";
import Nav from 'react-bootstrap/Nav';

const HeaderItem = ({
                      propActiveMenu = undefined,
                      propTitle = undefined,
                      propPath = undefined,
                      propIcon = undefined
                    }) => {

  useEffect(() => {
    console.log(propActiveMenu);
  }, [propActiveMenu]);

  useEffect(() => {
    // console.log(propTitle);
  }, [propTitle]);

  useEffect(() => {
    console.log(propPath);
  }, [propPath]);

  /*useEffect(() => {
    console.log(propIcon);
  }, [propIcon]);*/

  function isEmptyObj(obj) {
    return obj.constructor === Object && Object.keys(obj).length === 0;
  }

  return (
      <>
        {
          isEmptyObj(propActiveMenu) ?
              <NavLink to={`/ui${propPath}`}
                       className={'nav-link py-3 mx-1'}
              >
                {propTitle}
              </NavLink> :
              propPath === "/dash_platform" ?
                  <Nav.Link href="/ui/dash_platform" to="/ui/dash_platform"
                            className={propActiveMenu[0].menu_nm === propTitle ? 'nav-link active mt-2 fw-bold' : 'nav-link py-3 mx-1'}
                  >
                    {propTitle}
                  </Nav.Link> :
                  <NavLink to={`/ui${propPath}`}
                           className={propActiveMenu[0].menu_nm === propTitle ? 'nav-link active mt-2 fw-bold' : 'nav-link py-3 mx-1'}
                  >
                    {propTitle}
                  </NavLink>
        }

        {/*{propPath === "/dash_platform" ?
            <Nav.Link href="/ui/dash_platform" to="/ui/dash_platform"
                      className={propActiveMenu[0].menu_nm === propTitle ? 'nav-link active mt-2 fw-bold ddd' : 'nav-link py-3 mx-1'}
            >
              <FontAwesomeIcon icon={propIcon} className={'pe-2'}/ >
              {propTitle}
            </Nav.Link> :
            <NavLink to={`/ui${propPath}`}
                     className={propActiveMenu[0].menu_nm === propTitle ? 'nav-link active mt-2 fw-bold' : 'nav-link py-3 mx-1'}
            >
              <FontAwesomeIcon icon={propIcon} className={'pe-2'} />
              {propTitle}
            </NavLink>}*/}
      </>
      /*<NavLink to={`/ui${propPath}`}
               className={propActiveMenu === propTitle ? 'nav-link active mt-2 fw-bold' : 'nav-link py-3 mx-1'}
      >
        {/!*<FontAwesomeIcon icon={propIcon} className={'pe-2'}/>*!/}
        {propTitle}
      </NavLink>*/
  );
};

export default HeaderItem;
